import { render, staticRenderFns } from "./geo.vue?vue&type=template&id=cb12c536&lang=true&"
import script from "./geo.vue?vue&type=script&lang=js&"
export * from "./geo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports